'use strict';

import { assignDeep, isDev } from '../../../settings';
import { QualityCore } from './QualityCore';
import { getUrlParam } from '../../../functions';
import * as dat from 'dat.gui';

const DEFAULT_CONFIG = {
	pixelRatio: 2,
	composerSamples: 4,
	autoUpdateShadowMap: true,
	lodDistanceCoefficient: 2,
	shadowMapSize: 8192,
	shadowNormalBias: 1,
	tilesErrorTarget: 1,
	shadowCameraSize: 2000,
	castShadowForAnimatedObjects: true,
	optimizationTasks: false,
	cloudflareParams : {width: 4096}
};

export class HighQuality extends QualityCore{
	constructor () {
		const active = getUrlParam('quality') === 'high';
		let CONFIG = config.threejs.quality?.high || {};
		
		if (active && isDev) {
			const dataFromLS = localStorage.getItem('highQualityPreset');
			CONFIG = dataFromLS ? JSON.parse(dataFromLS) : JSON.parse(JSON.stringify(DEFAULT_CONFIG));
			const func = {
				reload: () => {
					window.location.reload();
				},
				onChange: () => {
					localStorage.setItem('highQualityPreset',JSON.stringify(CONFIG));
				}
			};
			const gui = new dat.GUI();
			gui.width = 400;
			gui.add(CONFIG,'pixelRatio',1,4,0.1).onChange(func.onChange);
			gui.add(CONFIG,'composerSamples',1,16,1).onChange(func.onChange);
			gui.add(CONFIG,'autoUpdateShadowMap').onChange(func.onChange);
			gui.add(CONFIG,'lodDistanceCoefficient',0.1,5,0.1).onChange(func.onChange);
			gui.add(CONFIG,'shadowMapSize',256,8192,1).onChange(func.onChange);
			gui.add(CONFIG,'shadowNormalBias',0,10,0.1).onChange(func.onChange);
			gui.add(CONFIG,'tilesErrorTarget',0,1000,0.1).onChange(func.onChange);
			gui.add(CONFIG,'shadowCameraSize',1,4000,1).onChange(func.onChange);
			gui.add(CONFIG,'castShadowForAnimatedObjects').onChange(func.onChange);
			gui.add(CONFIG.cloudflareParams,'width',128,8192,128).name('Cloudflare width').onChange(func.onChange);
			gui.add(func,'reload');
		}
		
		const cfg = active ? assignDeep({},DEFAULT_CONFIG,CONFIG) : {};
		super(cfg);
	}
}
